import { GQLPlugin } from '../GQLTypes';

function removeUnderscoredProperties (obj) {
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object') { removeUnderscoredProperties(obj[key]); }
    if (key.charAt(0) === '_') delete obj[key];
  });
}

export const RemoveUnderscoredPropertiesPlugin: GQLPlugin = ({ beforeRequest }) => {
  beforeRequest.push((fetchOpts: RequestInit) => {
    let newBody: { [key: string]: unknown };
    try {
      newBody = JSON.parse(fetchOpts.body as string);
    } catch {
      return;
    }
    if (newBody.variables) {
      removeUnderscoredProperties(newBody.variables);
      fetchOpts.body = JSON.stringify(newBody);
    }
  });
};
